export const I1 = [
    "Senza esperienza",
    "Principiante",
    "Esperienza di base",
    "Con esperienza",
    "Esperto"

];

export const I2 = [
    "Senza esperienza (DEEPSEA, COMAP, DEIF, ETC.)",
    "Principiante (DEEPSEA, COMAP, DEIF, ETC.)",
    "Esperienza di base (DEEPSEA, COMAP, DEIF, ETC.)",
    "Con esperienza (DEEPSEA, COMAP, DEIF, ETC.)",
    "Esperto (DEEPSEA, COMAP, DEIF, ETC.)"
];

export const I3 = [
    "Senza esperienza (BASLER, UNITROL, ETC.)",
    "Principiante (BASLER, UNITROL, ETC.)",
    "Esperienza di base (BASLER, UNITROL, ETC.)",
    "Con esperienza (BASLER, UNITROL, ETC.)",
    "Esperto (BASLER, UNITROL, ETC.)"
];

export const I4 = [
    "Si",
    "No",
    "Appoggiandosi ad aziende terze"
];

export const I5 = [
    "Fino a 200 KVA",
    "Fino a 500 KVA",
    "Fino a 1000 KVA",
    "Fino a 1500 KVA",
    "Fino a 2000 KVA",
    "Fino a 2500 KVA",
    "Fino a 3000 KVA",
    "Senza limiti"
];

export const I6 = [
    "No service in sito",
    "Fino a 500 Km",
    "Fino a 1000 Km ",
    "Sopra i 1000 Km (senza limiti)"
];

export const I7 = [
    "Nessuno",
    "Si da 1 a 5",
    "Si da 6 a 10",
    "Si più di 10"

];

export const I8 = [
    "Si",
    "No"
];

export const I9 = [
    "Si con laser",
    "Si con comparatore",
    "Si con altri metodi",
    "No"

];
export const I10 = [
    "Si servizio confermato",
    "Non disponibile"
];

export const I11 = [
    "Approvato",
    "Non approvato"
];


export const I12 = [
    "Nullo",
    "Povero",
    "Basico",
    "Buono",
    "Ottimo"
];

export const I13 = [
    "Service",
    "Meccalte"
];

export const IArea = [
    "Europa - Italia",
    "Europa - Spagna",
    "Europa - Regno Unito / EIRE",
    "Europa - Germania",
    "Europa - Francia",
    "Europa - Russia",
    "Europa - Altri Paesi",
    "Africa",
    "Nord America",
    "America Centrale",
    "Sud America",
    "Medio Oriente",
    "Estremo Oriente - India",
    "Estremo Oriente"
]


export const INotes = [
    "Il pulsante a destra riempie automaticamente il campo in base alle informazioni sopra elencate. Se queste informazioni non vengono riconosciute, immettere manualmente le coordinate, la latitudine e la longitudine, separate da una virgola <br> (esempio: 45.6515661 , 11.8564252, quindi la latitudine quindi uno spazio, quindi una virgola, quindi uno spazio e infine la longitudine).",
    "Tecnici per interventi in sito",
    "Per filiali o associate, compilare un nuovo SPQ questionario per ogni filiale",
    "Numero approssimativo di riparazioni / interventi fatti per conto Mecc Alte ",
    "Numero di riparazioni / interventi fatti per Mecc Alte negli ultimi 12 mesi, specificare il periodo",
    "Tariffa oraria standard per attività di officina",
    "Tariffa oraria standard per attività in sito",
    "Visitato / esaminato in data; specificare i visitatori meccalte",
    "Commentare il possibile rapporto di concorrenza con altri costruttori di alternatori",
    "Commentare il possibile rapporto di concorrenza con altri costuttori di gruppi elettrogeni",
    "Selezionare il livello qualitativo della reportistica e della corrispondenza",
    "Selezionare lo stato di approvazione e di autorizzazione del centro assistenza"
];